import { render } from "./person-certificate.vue?vue&type=template&id=3f1d9cc1&scoped=true"
import script from "./person-certificate.vue?vue&type=script&lang=js"
export * from "./person-certificate.vue?vue&type=script&lang=js"

import "./person-certificate.vue?vue&type=style&index=0&id=3f1d9cc1&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d9cc1"]])

export default __exports__